import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import LOGO from "../../assets/logo.png";
import HamburgerMenuIcon from "../../assets/hamburger-menu.svg";
import CloseHamburgerMenu from "../../assets/CloseIcon.svg";
import LanguageSwitcher from "../LanguageSwitcher";
import { useTranslation } from "react-i18next";

const NavContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  max-width: 1400px;
  height: 100px;
  @media (max-width: 480px) {
    justify-content: space-between;
    max-width: 480px; 
    padding: 0 24px 0 18px;
  }
`;

const LogoWrapper = styled.figure`
  width: 100%;
  max-width: 120px;
  height: 100%;
  max-height: 120px;
`;
const Logo = styled.img`
  width: 100%;
  height: 100%;
`;
const NavList = styled.div`
  list-style-type: none;
  display: flex;
  @media (max-width: 480px) {
    display: none;
  }
`;
const Language = styled.div`
  @media (max-width: 480px) {
    display: none;
  }
`
const NavListItems = styled(Link)`
  padding: 0 12px 0 12px;
  position: relative;
  text-decoration: none;
  color: black;
  &:hover {
    cursor: pointer;
  }
  &::after {
    content: "";
    position: absolute;
    height: 3px;
    background-color: rgba(29, 109, 193, 1);
    width: 0;
    bottom: -3px;
    align-self: center;
    pointer-events: none;
    right: 0;
    transition: all 300ms ease;
  }
  &:hover::after {
    width: 100%;
    left: 0;
  }
`;
const NavButton = styled.button`
    width: 100%;
    max-width: 340px;
    color: rgba(29, 109, 193, 1);
    background-color: transparent;
    border-radius: 5px;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0%
    line-height: 100%;
    padding: 12px 0 12px 0;
    border: 1px solid rgba(29, 109, 193, 1);

    &:hover {
        background-color: rgba(29, 109, 193, 1);
        color: #fff;
        transition: 400ms;
        cursor: pointer;
       
    }
    &:active {
        transform: translateY(+2px)  
    }
          @media (max-width: 480px) {
    display: none;
  }

`;
const HamburgerMenuWrapper = styled.figure`
  width: 100%;
  max-width: 40px;
  max-height: 40px;
  z-index: 999999999;
  display: none;
  @media (max-width: 480px) {
    display: block;
  }
`;
const HamburgerMenu = styled.img`
  width: 100%;
  max-width: 40px;
  max-height: 40px;
`;

export const NavBar = ({ setModalOpen, setMenuIsOpen, menuIsOpen }) => {
  const { t } = useTranslation();
  return (
    <NavContainer>
      <LogoWrapper>
        <Link to={"/"}>
          <Logo src={LOGO} />
        </Link>
      </LogoWrapper>
      <NavList>
        <NavListItems to={"/"}>{t('nav.nav-link-1')}</NavListItems>

        <NavListItems as="a" href="#services">
          {t('nav.nav-link-2')}
        </NavListItems>

        <NavListItems as="a" href="#services">
          {t('nav.nav-link-3')}
        </NavListItems>
        <NavListItems as="a" href="#partnership">
          {t('nav.nav-link-4')}
        </NavListItems>
        {/* <NavListItems as="a" href="#services">
          Blogs
        </NavListItems> */}
        <NavListItems as="a" href="#about-us">
          {t('nav.nav-link-5')}
        </NavListItems>
      </NavList>
      
      <NavButton onClick={() => setModalOpen(true)}>
        {t('nav.nav-link-6')}
      </NavButton>

          <Language><LanguageSwitcher /></Language>
      <HamburgerMenuWrapper>
        <HamburgerMenu
          onClick={() => setMenuIsOpen(!menuIsOpen)}
          src={menuIsOpen ? CloseHamburgerMenu : HamburgerMenuIcon}
          alt=""
        />
      </HamburgerMenuWrapper>
    </NavContainer>
  );
};
